<section>
    <p>
        When I'm not working I spend 90% of the time I'm hanging out with my beautiful wife Jennifer and muh 2 boy Gabe and Ben.
        Luckily they are completely different people but have overlapping interests with their old man. One is all about sports 
        and the other is a gamer like his pops.
    </p>

    <p>
        You'll either find me at soccer practice with Gabe, karate class with Ben, relaxing with Jen or my other current interest,
        game dev. Lately I've been prototyping games here and there while learning to use the Unity game engine.
    </p>

    <p>
        Once I'm done learning how to make em I usually end up playing them. Currently playing through Star Wars: Fallen Order and 
        Into the Breach(research for my current game prototype ;) until Elden Ring releases and consumes my free time.
    </p>
</section>

<style>
    section {
        text-align: left;
    }
</style>